import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// 🔥 AGORA USA SPRINT
export async function getIndicadores() {
  const res = await api.get("/sprint/resumo");
  return res.data;
}

export async function getAlertas() {
  // pode manter mock por enquanto
  return {
    alertas: []
  };
}